import { render, staticRenderFns } from "./AsideCommon.vue?vue&type=template&id=e812f1a6&scoped=true"
import script from "./AsideCommon.vue?vue&type=script&lang=js"
export * from "./AsideCommon.vue?vue&type=script&lang=js"
import style0 from "./AsideCommon.vue?vue&type=style&index=0&id=e812f1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e812f1a6",
  null
  
)

export default component.exports